import React from "react";

const sample = `curl -X POST https://api.trustdmarc.io/v1/domains \\
  -H "Authorization: Bearer $TRUSTDMARC_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"domain":"example.com"}'

# response
{
  "domain_id":      "dom_4f82ab2d",
  "verification": {
    "host":  "_trustdmarc.example.com",
    "type":  "TXT",
    "value": "trustdmarc-verification=a8f2c9..."
  },
  "status": "pending"
}`;

const webhook = `POST /your-endpoint
X-TrustDmarc-Signature: t=1739873402,v1=ab12...

{
  "event":   "spoof.spike",
  "tenant":  "org_4a2c",
  "domain":  "example.com",
  "source":  "185.220.101.42",
  "score":   0.94,
  "ts":      "2026-02-18T11:42:08Z"
}`;

export default function Developers() {
  return (
    <div>
      <section className="pt-20 pb-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-600 mb-5">Developers</div>
          <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] ink">
            Edge-native<br /><span className="font-serif italic font-normal">security APIs.</span>
          </h1>
          <p className="mt-7 text-lg ink-soft leading-relaxed">
            TrustDmarc exposes every product surface through stable REST endpoints, signed webhooks, and Terraform modules.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-5">
          <div className="panel-shadow p-2">
            <div className="px-5 pt-4 pb-3 flex items-center justify-between">
              <div className="text-xs font-semibold ink">Register a domain</div>
              <div className="font-mono text-xs ink-muted">POST /v1/domains</div>
            </div>
            <pre className="font-mono text-xs text-stone-300 bg-[#0F0E0C] rounded-lg p-5 overflow-x-auto whitespace-pre">{sample}</pre>
          </div>
          <div className="panel-shadow p-2">
            <div className="px-5 pt-4 pb-3 flex items-center justify-between">
              <div className="text-xs font-semibold ink">Webhook payload</div>
              <div className="font-mono text-xs ink-muted">HMAC-SHA256</div>
            </div>
            <pre className="font-mono text-xs text-stone-300 bg-[#0F0E0C] rounded-lg p-5 overflow-x-auto whitespace-pre">{webhook}</pre>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-4">
          {[
            { t: "Authentication", d: "Bearer tokens with scoped permissions and tenant binding." },
            { t: "Rate limits", d: "10k req/day Pro · 1M req/day Enterprise · burst-protected." },
            { t: "Signature verification", d: "HMAC-SHA256 with replay-resistant timestamp window." },
          ].map((x) => (
            <div key={x.t} className="panel p-7">
              <div className="font-display text-lg font-bold ink">{x.t}</div>
              <p className="mt-2 text-sm ink-soft">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
